var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.message.type,{tag:"component",attrs:{"message":_vm.message},on:{"msg":function($event){return _vm.passScrollEvent($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }